// extracted by mini-css-extract-plugin
export default {"modalOverlay":"iC-z","modalContent":"jC-z","header":"kC-z","close":"lC-z"};